import React from 'react';
import PropTypes from 'prop-types';

const TableData = ({ children, colSpan, className }) => {
  return (
    <td
      colSpan={colSpan}
      className={`px-[9px] py-[16px] text-romanSilver dark:text-secondary font-normal
      text-left text-[13px] align-middle ${className || ''}`}
    >
      {children}
    </td>
  );
};

TableData.propTypes = {
  children: PropTypes.node,
  colSpan: PropTypes.number,
  className: PropTypes.string
};

TableData.defaultProps = {
  children: undefined,
  colSpan: 1,
  className: undefined
};

export default TableData;
